import React, { Component } from 'react';
import { browserHistory } from 'react-router';

class Search extends Component {

	constructor(props) {
		super(props);
		this.search = this.search.bind(this);
		this.searchValueUpdate = this.searchValueUpdate.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.searchStarted && nextProps.searchCompleted) {
			// reset search flags, so a new search will be possible
			this.props.toggleSearchStarted();
			this.props.toggleSearchCompleted();
			if (nextProps.photos.length > 0) {
				this.goToRoute('gallery');
			} else {
				alert('No photos were found. Please consider modifying your search query.');
			}
		}
	}

	componentDidMount() {
		this.props.dispatchAdjustUI();
	}

	search() {
		if (this.props.searchQuery.length === 0) {
			alert('Please first enter a search query.');
			return;
		}
		this.props.toggleSearchStarted();
		this.props.onSearchClick(this.props.searchQuery);
	};

	searchValueUpdate(event) {
		this.props.onSearchQueryInput(event.target.value);
	}

	goToRoute(path) {
		browserHistory.push('/' + path);
	}

	goToExternalSite(e) {
		var url = e.target.getAttribute('data-link');
		window.location.href = url;
	}

	render() {
		return (
			<form className="search-form">
				<label className="search-label">Search for Flickr Images:</label>
				<input onChange={this.searchValueUpdate} type="text" value={this.props.searchQuery} className="search-input"></input>
				<input onClick={this.search} disabled={this.props.searchStarted} value="Flickr Search" readOnly="readonly" className="search-submit"></input>
				{ this.props.searchStarted ? <i className="fa fa-refresh fa-spin"></i> : null }
				<div className="link" onClick={this.goToExternalSite} data-link="http://www.danielcsite.com/flickr">Click here for an Angular version of this Flickr photos app...</div>
			</form>
		)
	}
}

export default Search;



/** WEBPACK FOOTER **
 ** ./src/search/Search.js
 **/